import * as React from 'react'
import { FluentIconsProps, wrapIcon } from '@fluentui/react-icons'

export const HammockIcon = wrapIcon((props: FluentIconsProps) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            height="1rem"
            viewBox="0 0 300 300"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <path
                opacity="0.000000"
                stroke="none"
                d="
M1.000000,110.000000
	C1.000000,73.348404 1.000000,37.196804 1.000000,1.022603
	C100.943260,1.022603 200.886536,1.022603 300.914917,1.022603
	C300.914917,100.901535 300.914917,200.803177 300.914917,300.852417
	C201.000168,300.852417 101.000107,300.852417 1.000000,300.852417
	C1.000000,237.446915 1.000000,173.973465 1.000000,110.000000
M290.077728,204.573273
	C295.967499,190.625519 298.866058,175.918640 299.864624,160.958191
	C300.875549,145.812256 299.694519,130.692322 296.003021,115.864418
	C290.250885,92.759087 279.844666,71.928604 264.303436,53.954021
	C249.318176,36.622463 231.298584,23.100760 210.105118,13.997113
	C194.248337,7.185845 177.681076,3.160959 160.533203,2.119481
	C147.367477,1.319859 134.229782,2.223825 121.187996,4.910886
	C95.949951,10.110802 73.401642,20.892702 54.028725,37.672646
	C37.651878,51.857533 24.567314,68.727715 15.509979,88.736755
	C7.952690,105.431961 3.421313,122.792130 2.140013,140.897079
	C1.068704,156.034821 2.305717,171.159348 5.990396,185.990875
	C11.730103,209.094299 22.018887,229.980209 37.591549,247.946152
	C52.593906,265.254181 70.603600,278.815002 91.758652,287.960968
	C107.591263,294.805908 124.174088,298.829224 141.321381,299.878387
	C154.485779,300.683807 167.615616,299.724670 180.668320,297.102509
	C205.962967,292.021149 228.416000,281.061371 247.874725,264.437378
	C266.713898,248.342651 280.868439,228.572922 290.077728,204.573273
z"
            />
            <path
                fill="#0F6FB7"
                opacity="1.000000"
                stroke="none"
                d="
M290.008850,204.963684
	C280.868439,228.572922 266.713898,248.342651 247.874725,264.437378
	C228.416000,281.061371 205.962967,292.021149 180.668320,297.102509
	C167.615616,299.724670 154.485779,300.683807 141.321381,299.878387
	C124.174088,298.829224 107.591263,294.805908 91.758652,287.960968
	C70.603600,278.815002 52.593906,265.254181 37.591549,247.946152
	C22.018887,229.980209 11.730103,209.094299 5.990396,185.990875
	C2.305717,171.159348 1.068704,156.034821 2.140013,140.897079
	C3.421313,122.792130 7.952690,105.431961 15.509979,88.736755
	C24.567314,68.727715 37.651878,51.857533 54.028725,37.672646
	C73.401642,20.892702 95.949951,10.110802 121.187996,4.910886
	C134.229782,2.223825 147.367477,1.319859 160.533203,2.119481
	C177.681076,3.160959 194.248337,7.185845 210.105118,13.997113
	C231.298584,23.100760 249.318176,36.622463 264.303436,53.954021
	C279.844666,71.928604 290.250885,92.759087 296.003021,115.864418
	C299.694519,130.692322 300.875549,145.812256 299.864624,160.958191
	C298.866058,175.918640 295.967499,190.625519 290.008850,204.963684
M277.748444,136.633896
	C275.537384,138.758453 273.326324,140.882996 270.933350,142.172165
	C270.539307,138.867233 270.358398,135.520477 269.719238,132.263641
	C260.116547,83.332794 231.997986,49.778046 184.107529,35.909359
	C136.558441,22.139530 95.101562,35.325970 61.182922,71.430779
	C49.375492,83.999245 41.802464,99.132271 35.403885,114.836006
	C31.002213,108.903946 26.600540,102.971893 22.198866,97.039833
	C21.907749,97.241928 21.616631,97.444023 21.325514,97.646118
	C25.361488,107.041260 29.397465,116.436409 33.268909,126.696434
	C25.477749,171.074448 37.353024,209.268784 70.509407,239.885300
	C119.231468,284.875153 195.135574,281.000885 239.868637,231.601608
	C260.186768,209.164078 270.939423,182.727158 271.134308,151.529785
	C273.819153,146.740250 276.503998,141.950699 279.647736,136.794250
	C279.650879,136.339493 279.653992,135.884735 279.657104,135.429993
	C279.213623,135.727341 278.770111,136.024704 277.748444,136.633896
z"
            />
            <path
                fill="#FFFFFF"
                opacity="1.000000"
                stroke="none"
                d="
M35.982586,115.212219
	C41.802464,99.132271 49.375492,83.999245 61.182922,71.430779
	C95.101562,35.325970 136.558441,22.139530 184.107529,35.909359
	C231.997986,49.778046 260.116547,83.332794 269.719238,132.263641
	C270.358398,135.520477 270.539307,138.867233 270.875305,142.893311
	C259.343170,155.571243 246.613480,166.009216 232.491318,174.666595
	C192.341415,199.279968 151.220688,201.496704 109.129585,179.737610
	C84.467819,166.988617 64.321777,148.717041 46.098911,128.129105
	C42.480701,124.041306 39.342262,119.528847 35.982586,115.212219
z"
            />
            <path
                fill="#FEFDFE"
                opacity="1.000000"
                stroke="none"
                d="
M270.851013,152.194397
	C270.939423,182.727158 260.186768,209.164078 239.868637,231.601608
	C195.135574,281.000885 119.231468,284.875153 70.509407,239.885300
	C37.353024,209.268784 25.477749,171.074448 33.530865,126.556068
	C37.133022,132.907883 40.415886,139.430313 43.823368,145.886993
	C58.419189,173.543915 74.896690,199.790192 98.887703,220.554489
	C128.998489,246.615448 163.883331,249.923553 198.012329,229.698120
	C212.752502,220.962860 225.908081,210.130096 236.754028,196.985031
	C248.686813,182.522736 259.532013,167.163086 270.851013,152.194397
z"
            />
            <path
                fill="#EA4D94"
                opacity="1.000000"
                stroke="none"
                d="
M270.992676,151.862091
	C259.532013,167.163086 248.686813,182.522736 236.754028,196.985031
	C225.908081,210.130096 212.752502,220.962860 198.012329,229.698120
	C163.883331,249.923553 128.998489,246.615448 98.887703,220.554489
	C74.896690,199.790192 58.419189,173.543915 43.823368,145.886993
	C40.415886,139.430313 37.133022,132.907883 33.613129,126.123627
	C29.397465,116.436409 25.361488,107.041260 21.325514,97.646118
	C21.616631,97.444023 21.907749,97.241928 22.198866,97.039833
	C26.600540,102.971893 31.002213,108.903946 35.693237,115.024109
	C39.342262,119.528847 42.480701,124.041306 46.098911,128.129105
	C64.321777,148.717041 84.467819,166.988617 109.129585,179.737610
	C151.220688,201.496704 192.341415,199.279968 232.491318,174.666595
	C246.613480,166.009216 259.343170,155.571243 270.966309,143.311005
	C273.326324,140.882996 275.537384,138.758453 278.241791,136.699341
	C278.886353,136.896912 279.037598,137.029022 279.188812,137.161148
	C276.503998,141.950699 273.819153,146.740250 270.992676,151.862091
z"
            />
            <path
                fill="#EA4D94"
                opacity="1.000000"
                stroke="none"
                d="
M278.530884,136.543427
	C278.770111,136.024704 279.213623,135.727341 279.657104,135.429993
	C279.653992,135.884735 279.650879,136.339493 279.418274,136.977692
	C279.037598,137.029022 278.886353,136.896912 278.530884,136.543427
z"
            />
        </svg>
    )
}, 'HammockIcon')
